import { Box, IconButton, Typography, Card, Skeleton } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";


import CloseIcon from "@mui/icons-material/Close";
import Slider from "react-slick";
import PlotMap from "../Plot_marketPlace/PlotMap";

export default function GiooleftCard({ title, images = [], lat, lng, loading, map_set = [], propertyName = "", youtubeLink, whatsappNumber }) {
  const isVideo = (url) => {
    if (typeof url !== 'string') return false;
    return url.match(/\.(mp4|webm|mkv|mov|avi)$/i);
  };

  // const images = [
  //   "/assets/images/steel.png",
  //   "/assets/images/cement.png",
  //   "/assets/images/tiles.png",
  // ];

  const allImages = Array.isArray(images) ? images : (typeof images === 'string' ? [images] : []);
  const safeImage = allImages.length > 0 ? allImages : ["/assets/images/placeholder_img.png"];
  const [openPreview, setOpenPreview] = useState(false);
  const previewSliderRef = useRef();
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRefs = useRef({});
  const [playingVideo, setPlayingVideo] = useState(null);
  const [loadedMedia, setLoadedMedia] = useState({});
  const [hoveredVideo, setHoveredVideo] = useState(null);

  const handleMediaLoad = (src) => {
    setLoadedMedia((prev) => ({ ...prev, [src]: true }));
  };

  const togglePlay = (e, src) => {
    e.stopPropagation();
    const video = videoRefs.current[src];
    if (video) {
      if (video.paused) {
        if (playingVideo && playingVideo !== src && videoRefs.current[playingVideo]) {
          videoRefs.current[playingVideo].pause();
        }
        video.play();
        setPlayingVideo(src);
      } else {
        video.pause();
        setPlayingVideo(null);
      }
    }
  };

  const handleImagePreview = (idx) => {
    setActiveIndex(idx);
    setOpenPreview(true);

    setTimeout(() => {
      previewSliderRef.current?.slickGoTo(idx);
    }, 100);
  };

  const cardSliderSettings = {
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    infinite: false,
  };



  const handleShare = () => {
    const shareUrl = window.location.href;

    if (navigator.share) {
      navigator.share({
        title: title || "Property",
        text: "Check out this property",
        url: shareUrl,
      });
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard");
    }
  };

  const isValidLocation =
    lat !== null &&
    lng !== null &&
    lat !== "" &&
    lng !== "" &&
    !isNaN(lat) &&
    !isNaN(lng);


  return (
    <Card
      sx={{
        width: "100%",
        // width: 450,
        backgroundImage: `url('/assets/images/plootbg.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        mx: "auto",
        p: 2,
        borderRadius: 4,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        width: { xs: "100%", sm: 350, md: 450 },
      }}
    >
      <Typography textAlign={"center"} sx={{ pb: 1.5, fontWeight: 700, fontSize: 19 }}>{title || ""}</Typography>
      <Box>
        {/* IMAGE AREA */}
        <Box
          sx={{
            width: "100%",
            height: 280,
            borderRadius: 4,
            overflow: "hidden",
            position: "relative",
          }}
        >
          {loading ? (
            <Skeleton
              variant="rectangular"
              animation="wave"
              width="100%"
              height="100%"
              sx={{ borderRadius: 2 }}
            />
          ) : safeImage.length > 1 ? (
            <Box
              sx={{
                width: "100%",
                height: 280,
                position: "relative",
                "& .slick-slider, & .slick-list, & .slick-track, & .slick-slide > div": {
                  height: "100% !important",
                },
              }}
            >
              <Slider {...cardSliderSettings} ref={sliderRef}>
                {safeImage.map((img, i) => (
                  <Box key={i}>
                    {isVideo(img) ? (
                      <Box sx={{ position: "relative", width: "100%", height: 280 }}>
                        {!loadedMedia[img] && (
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height="100%"
                            sx={{ position: "absolute", top: 0, left: 0 }}
                          />
                        )}
                        <Box
                          onMouseEnter={() => setHoveredVideo(img)}
                          onMouseLeave={() => setHoveredVideo(null)}
                          sx={{ position: "relative", width: "100%", height: "100%" }}
                        >
                          <video
                            ref={(el) => (videoRefs.current[img] = el)}
                            src={img}
                            playsInline
                            disablePictureInPicture
                            disableRemotePlayback
                            controlsList="nopictureinpicture"
                            preload="metadata"
                            onLoadedData={() => handleMediaLoad(img)}
                            onClick={(e) => {
                              if (playingVideo !== img) {
                                togglePlay(e, img);
                              } else {
                                handleImagePreview(i);
                              }
                            }}
                            style={{
                              width: "100%",
                              height: 280,
                              objectFit: "cover",
                              cursor: "pointer",
                              transition: "transform 0.3s ease",
                              display: loadedMedia[img] ? "block" : "none",
                            }}
                          />
                          {loadedMedia[img] && playingVideo !== img && (
                            <IconButton
                              onClick={(e) => togglePlay(e, img)}
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "#fff",
                                bgcolor: "rgba(0,0,0,0.3)",
                                borderRadius: "4px", // Rectangular
                                "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
                              }}
                            >
                              <PlayArrowIcon sx={{ fontSize: 40 }} />
                            </IconButton>
                          )}
                          {loadedMedia[img] && playingVideo === img && hoveredVideo === img && (
                            <IconButton
                              onClick={(e) => togglePlay(e, img)}
                              sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "#fff",
                                bgcolor: "rgba(0,0,0,0.3)",
                                borderRadius: "4px", // Rectangular
                                "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
                              }}
                            >
                              <PauseIcon sx={{ fontSize: 40 }} />
                            </IconButton>
                          )}
                        </Box>
                      </Box>
                    ) : (
                      <Box sx={{ position: "relative", width: "100%", height: 280 }}>
                        {!loadedMedia[img] && (
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height="100%"
                            sx={{ position: "absolute", top: 0, left: 0 }}
                          />
                        )}
                        <img
                          src={img || "/assets/images/placeholder_img.png"}
                          alt="preview"
                          onLoad={() => handleMediaLoad(img)}
                          onClick={() => handleImagePreview(i)}
                          style={{
                            width: "100%",
                            height: 280,
                            objectFit: "cover",
                            cursor: "zoom-in",
                            transition: "transform 0.3s ease",
                            display: loadedMedia[img] ? "block" : "none",
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                ))}
              </Slider>
            </Box>
          ) : (
            isVideo(safeImage[0]) ? (
              <Box sx={{ position: "relative", width: "100%", height: 280 }}>
                {!loadedMedia[safeImage[0]] && (
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{ position: "absolute", top: 0, left: 0 }}
                  />
                )}
                <Box
                  onMouseEnter={() => setHoveredVideo(safeImage[0])}
                  onMouseLeave={() => setHoveredVideo(null)}
                  sx={{ position: "relative", width: "100%", height: "100%" }}
                >
                  <video
                    ref={(el) => (videoRefs.current[safeImage[0]] = el)}
                    src={safeImage[0]}
                    playsInline
                    disablePictureInPicture
                    disableRemotePlayback
                    controlsList="nopictureinpicture"
                    preload="metadata"
                    onContextMenu={(e) => e.preventDefault()}
                    onLoadedData={() => handleMediaLoad(safeImage[0])}
                    onClick={(e) => {
                      if (playingVideo !== safeImage[0]) {
                        togglePlay(e, safeImage[0]);
                      } else {
                        handleImagePreview(0);
                      }
                    }}
                    style={{
                      width: "100%",
                      height: 280,
                      objectFit: "cover",
                      cursor: "pointer",
                      display: loadedMedia[safeImage[0]] ? "block" : "none",
                    }}
                  />
                  {loadedMedia[safeImage[0]] && playingVideo !== safeImage[0] && (
                    <IconButton
                      onClick={(e) => togglePlay(e, safeImage[0])}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#fff",
                        bgcolor: "rgba(0,0,0,0.3)",
                        "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
                      }}
                    >
                      <PlayArrowIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                  )}
                  {loadedMedia[safeImage[0]] && playingVideo === safeImage[0] && hoveredVideo === safeImage[0] && (
                    <IconButton
                      onClick={(e) => togglePlay(e, safeImage[0])}
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#fff",
                        bgcolor: "rgba(0,0,0,0.3)",
                        "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
                      }}
                    >
                      <PauseIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                  )}
                </Box>
              </Box>
            ) : (
              <Box sx={{ position: "relative", width: "100%", height: 280 }}>
                {!loadedMedia[safeImage[0]] && (
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{ position: "absolute", top: 0, left: 0 }}
                  />
                )}
                <img
                  src={safeImage[0] || "/assets/images/placeholder_img.png"}
                  alt="preview"
                  onLoad={() => handleMediaLoad(safeImage[0])}
                  onClick={() => handleImagePreview(0)}
                  style={{
                    width: "100%",
                    height: 280,
                    objectFit: "cover",
                    cursor: "zoom-in",
                    display: loadedMedia[safeImage[0]] ? "block" : "none",
                  }}
                />
              </Box>
            )
          )}

          {/* Right arrow */}
          {safeImage?.length > 1 && (
            <IconButton
              onClick={(e) => { e.stopPropagation(); sliderRef.current?.slickNext(); }}
              sx={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(255,255,255,0.7)",
                zIndex: 2,
                "&:hover": { background: "white" },
              }}
            >
              <ArrowForwardIosIcon fontSize="small" />
            </IconButton>
          )}

          {/* Left arrow */}
          {safeImage?.length > 1 && (
            <IconButton
              onClick={(e) => { e.stopPropagation(); sliderRef.current?.slickPrev(); }}
              sx={{
                position: "absolute",
                left: 8,
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(255,255,255,0.7)",
                zIndex: 2,
                "&:hover": { background: "white" },
              }}
            >
              <ArrowBackIosNewIcon fontSize="small" />
            </IconButton>
          )}

          {/* Share Icon (top-right) */}
          <IconButton
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              background: "white",

            }}
            onClick={handleShare}
          >
            <ShareIcon fontSize="small" />
          </IconButton>

          {/* WhatsApp Icon (next to share) */}
          <IconButton
            sx={{
              position: "absolute",
              top: 10,
              right: 50,
              background: "white",
              "&:hover": { background: "#f5f5f5" },
            }}
            onClick={(e) => {
              e.stopPropagation();
              const shareUrl = window.location.href;
              const shareText = `Check out this property: ${title || "Property"}\n${shareUrl}`;
              window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`, "_blank");
            }}
          >
            <WhatsAppIcon sx={{ color: "#25D366" }} fontSize="small" />
          </IconButton>

          {/* YouTube Icon (straight bottom to share icon) */}
          {youtubeLink && (
            <IconButton
              sx={{
                position: "absolute",
                bottom: 10,
                right: 10,
                background: "white",
                "&:hover": { background: "#f5f5f5" },
              }}
              onClick={() => window.open(youtubeLink, "_blank")}
            >
              <YouTubeIcon sx={{ color: "#FF0000" }} fontSize="small" />
            </IconButton>
          )}
        </Box>

        {/* Pagination Dots (informational) */}
        {safeImage?.length > 1 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
            {safeImage.map((_, i) => (
              <Box
                key={i}
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: i === activeIndex ? "black" : "#ccc",
                  mx: 0.7,
                  transition: "background 0.3s ease",
                }}
              />
            ))}
          </Box>
        )}
      </Box>

      <Box>
        {/* LOCATION TITLE */}
        <Typography
          sx={{
            mt: 2,
            fontWeight: 600,
            fontSize: "16px",
          }}
        >
          Location:
        </Typography>

        {/* MAP PLACEHOLDER (EMPTY SPACE) */}
        <Box
          sx={{
            width: "100%",
            height: 250,
            borderRadius: 4,
            mt: 1,
            background: "#f7f7f7",
            border: "1px solid #e5e5e5",
            textAlign: "center",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // important for rounded corners
          }}
        >
          {isValidLocation ? (
            <iframe
              title="Property Location Map"
              src={`https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
              width="100%"
              height="100%"
              style={{
                width: "100%",
                height: "100%",
                border: 0,
              }}
              allowFullScreen

              referrerPolicy="no-referrer-when-downgrade"
            />
          ) : (
            <Typography
              textAlign="center"
              sx={{
                color: "#999",
                fontSize: 14,
                textAlign: "center",
                px: 2,
              }}
            >
              Location not available
            </Typography>
          )}
        </Box>

      </Box>

      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "hidden",
            bgcolor: "rgba(0,0,0,0.5)",
          },
        }}
      >
        {/* CLOSE BUTTON (TOP RIGHT) */}
        <IconButton
          onClick={() => setOpenPreview(false)}
          sx={{
            position: "absolute",
            top: { xs: 10, sm: 16 },
            right: { xs: 10, sm: 20 },
            zIndex: 10,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              position: "relative",
              height: { xs: 320, sm: 500, md: 600 },
              bgcolor: "transparent",
              overflow: "hidden"
            }}
          >
            {/* LEFT ARROW */}
            {safeImage.length > 1 && (
              <IconButton
                onClick={() => previewSliderRef.current?.slickPrev()}
                sx={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 3,
                  color: "#fff",
                  bgcolor: "rgba(0,0,0,0.5)",

                  "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
            )}
            {/* SLIDER */}
            <Slider
              ref={previewSliderRef}
              initialSlide={activeIndex}
              beforeChange={(old, next) => setActiveIndex(next)}
              dots
              infinite
              speed={400}
              slidesToShow={1}
              slidesToScroll={1}
              arrows={false}
            >
              {safeImage?.map((img, i) => (
                <Box key={i}>
                  <Box
                    sx={{
                      height: { xs: 320, sm: 500, md: 600 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "rgba(0,0,0,0.5)",
                      p: 1,
                      position: "relative",
                    }}
                  >
                    {!loadedMedia[img] && (
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height="100%"
                        sx={{ position: "absolute", top: 0, left: 0, bgcolor: "rgba(255,255,255,0.1)" }}
                      />
                    )}
                    {isVideo(img) ? (
                      <video
                        src={img}
                        controls
                        disablePictureInPicture
                        disableRemotePlayback
                        controlsList="nopictureinpicture"
                        onLoadedData={() => handleMediaLoad(img)}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          display: loadedMedia[img] ? "block" : "none",
                        }}
                      />
                    ) : (
                      <img
                        src={img}
                        alt=""
                        onLoad={() => handleMediaLoad(img)}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          display: loadedMedia[img] ? "block" : "none",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              ))}
            </Slider>

            {/* RIGHT ARROW */}
            {safeImage.length > 1 && (
              <IconButton
                onClick={() => previewSliderRef.current?.slickNext()}
                sx={{
                  position: "absolute",
                  right: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 3,
                  color: "#fff",
                  bgcolor: "rgba(0,0,0,0.5)",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            )}

            {/* slide counter badge */}
            {safeImage.length > 1 && (
              <Box sx={{ position: "absolute", bottom: 12, left: "50%", transform: "translateX(-50%)", bgcolor: "rgba(0,0,0,0.5)", color: "#fff", borderRadius: "12px", px: 1.5, py: 0.3, fontSize: 13, pointerEvents: "none", zIndex: 3 }}>
                {activeIndex + 1} / {safeImage.length}
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </Card>
  );
}
